const doorPlacementTypes = {
  first: 'first',
  middle: 'middle',
  last: 'last',
};

export default doorPlacementTypes;
